module.exports = __webpack_public_path__ + "static/media/34 - Jurassic 5 - Thin Line.661f3c27.mp3";